'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var foo = function () {
    function foo() {
        _classCallCheck(this, foo);
    }

    _createClass(foo, [{
        key: 'bar',
        value: function bar() {
            console.log('bar');
        }
    }]);

    return foo;
}();

var ______fooooo = function ______fooooo(f) {
    console.log(f);
    return new Promise(function (res, rej) {
        console.log('p');
        res(true);
    });
};
var Menu = {

    init: function init() {

        $(function () {
            Menu.itemClick();
        });
    },

    itemClick: function itemClick() {

        $(".menu-button").click(function (e) {
            e.preventDefault();

            var isMenuVisible = $(".menu-item").is(":visible");
            isMenuVisible ? $(".menu-item").css("display", "") : $(".menu-item").show();
        });
    }

};

Menu.init();
window.onload = function () {
    var cultureSelect = document.getElementById('cultureSelect');
    var cultureForm = document.getElementById('selectLanguageForm');

    if (cultureSelect && cultureForm) {
        cultureSelect.onchange = function () {
            cultureForm.submit();
        };
    }
};
Holder.addTheme('thumb', {
    bg: '#55595c',
    fg: '#eceeef',
    text: 'Thumbnail'
});
//window.addEventListener("load", function () {
//    window.cookieconsent.initialise({
//        "content": {
//            "message": "This website uses cookies to keep you logged in and ensure that you get the best experience on our website. Your personal data never leaves this website until you explicitly allow for it in consent screen.",
//            "target": "_self"
//        }
//    });
//});
$(function () {
    //The passed argument has to be at least a empty object or a object with your desired options
    $('.overlayscrollbar').overlayScrollbars({});
    $('textarea').overlayScrollbars({
        resize: 'vertical',
        sizeAutoCapable: false
    });
});
$(function () {
    var _validation = function _validation(selector, event) {
        var form = $(selector)[0];
        var result = form.checkValidity();
        if (result === false) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        form.classList.add('was-validated');
        return result;
    };
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = $('.needs-validation');
    // Loop over them and prevent submission
    $(forms).each(function (idx) {
        var f = $(this); // current form
        $('.validation-invoker').click(function (event) {
            var result = _validation(f, event);
            return result;
        });
    });
});
/*!
 * page shared web components
 * 页面公共组件
 */
var AppWebComponents = {
    ShowLoadingInit: function ShowLoadingInit() {
        $('#global-spinnerModal').modal('show');
    },
    ShowLoading: function ShowLoading(title, content, icon) {
        console.log('init global loading..');
        icon = icon || 'fas fa-5x fa-spin fa-circle-notch';
        $('#global-spinnerModal-title').text(title);
        $('#global-spinnerModal-content').text(content);
        $('#global-spinnerModal-icon').html('<i class="pt-2 pb-2 ' + icon + '"></i>');
        $('#global-spinnerModal').modal('show');
    },
    RemoveLoading: function RemoveLoading() {
        console.log('dismiss global loading...');
        //removeLoading('loading');
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                $('html').removeClass('start-with-loading');
                console.log('modal hide');
                $('#global-spinnerModal').modal('hide');
                resolve(true);
            }, 20);
        });
    },
    PageRedirect: function PageRedirect(url, ev) {
        ev.preventDefault();
        window.location.replace(url);
        return false;
    },
    UpdateQueryString: function UpdateQueryString(key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null) return url.replace(re, '$1' + key + "=" + value + '$2$3');else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += '#' + hash[1];
                return url;
            }
        } else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += '#' + hash[1];
                return url;
            } else return url;
        }
    }
};
//# sourceMappingURL=app.build.js.map
